// Import standards
import axios from 'axios';
import { useEffect, useState } from 'react';

// Bulma Components
import { Columns, Heading, Tag, Box } from 'react-bulma-components';

// Material Design Icon Components
import Icon from "@mdi/react";
import { mdiClockTimeEightOutline } from '@mdi/js';

// API KEY
const API_KEY = "4NFRCY2DR37D";

// Component to display country's timezone
const TimezoneClock = (props) => {
    const [timezone, setTimezone] = useState([]);
    const [date, setDate] = useState(new Date());

    const tick = () => {
        setDate(new Date());
        
    }

    // Axios to get timezone data
    useEffect(() => {
        axios.get(`https://api.timezonedb.com/v2.1/get-time-zone?key=${API_KEY}&by=position&format=json&lat=${props.latlon[0]}&lng=${props.latlon[1]}`)
        .then(res => {
            setTimezone(res.data);
        })
    }, [props.latlon]); //check for changes in latitude and longtitude

    // invoked tick to update the time on HTML
    useEffect(() => {
        setInterval(() => tick(), 10000);

        // clearInterval when component is unmounted
        return() => {
            clearInterval(tick());
        };
    }, []);

    // convert local time to time of the country's timezone
    let clock =  date.toLocaleTimeString('en-US', {timeZone: timezone.zoneName, hour12: false})

    return (
        <Columns.Column size={5}>
            <Box> 
                <Tag.Group hasAddons marginless>
                <Heading size="medium" renderAs={Tag} textWeight="semibold" textColor="dark" subtitle>Local Time</Heading>
                <Tag size="medium" backgroundColor="warning"><Icon size={1} path={mdiClockTimeEightOutline}/></Tag>
                </Tag.Group>
                <Heading textColor="black" textSize={1}>
                    {
                    // cut second digits and only display hours and minutes
                    clock.slice(0,5)
                    } 
                    {/* display local UTC for the country */}
                <Heading renderAs="span" textColor="link" textSize={6}  subtitle>{props.local}</Heading>
                </Heading>
            </Box>
        </Columns.Column>
    );
};


export default TimezoneClock;